import classes from './IconButton.module.css';

interface IIconButtonProps {
    children: JSX.Element;
    onClick: (() => void) | ((e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void);
    isDisabled?: boolean;
    column?: boolean;
    type?: 'button' | 'submit';
    position?: string;
    title?: string;
}

const IconButton: React.FC<IIconButtonProps> = ({ children, onClick, isDisabled, type = 'button', column, position, title }) => {
    const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.preventDefault();
        onClick(e);
    };

    return (
        <button
            onClick={handleClick}
            className={`${classes.button} ${column ? classes.column : ''} ${position ? classes[position] : ''}`}
            title={title}
            disabled={isDisabled}
            type={type}
        >
            {children}
        </button>
    );
};

export default IconButton;
